import { connectInfiniteHits } from 'instantsearch.js/es/connectors'
import hitFund from './hitFund'
import hitNews from './hitNews'
import hitContribution from './hitContribution'
import hitTalent from './hitTalent'

let isInit = true
let isInit2 = true

const renderInfiniteHits = (renderOptions, isFirstRender) => {
  const { hits, widgetParams, showMore, isLastPage } = renderOptions

  if (isFirstRender) {
    const nextButtonWrapper = document.createElement('div')
    const nextButton = document.createElement('button')

    nextButtonWrapper.className = 'text-center mt-10'
    nextButton.className = 'button button--dark-green next-button'
    nextButton.innerHTML = `<span>${config.trads['news-list.more']}</span><svg width="12" height="12"><use href="#icon-plus" xlink:href="#icon-plus" /></svg>`
    nextButton.addEventListener('click', () => {
      showMore()
    })

    widgetParams.container.appendChild(nextButtonWrapper)
    nextButtonWrapper.appendChild(nextButton)

    return
  }

  widgetParams.container.querySelector('.next-button').disabled = isLastPage

  if (widgetParams.container.querySelector('.empty')) {
    widgetParams.container.querySelector('.empty').remove()
    widgetParams.container.querySelector('ul').nextElementSibling.classList.remove('hidden')
    widgetParams.container.querySelector('ul').nextElementSibling.classList.add('flex')
  }

  if (hits.length !== 0) {
    widgetParams.container.querySelector('ul').innerHTML = ''

    hits.forEach((hit) => {
      // create li element, add classes
      const li = document.createElement('li')

      if (widgetParams.type === 'fund') {
        li.className = 'col-12 md-col-6 xl-col-4 mb-4 md:mb-10 flex'
        li.innerHTML = hitFund(hit, isInit)
      } else if (widgetParams.type === 'contribution') {
        li.className = 'contributions-list__item'
        li.innerHTML = hitContribution(hit, isInit)
      } else if (widgetParams.type === 'news') {
        li.className = 'news-list__item news-list__item--grid flex'
        li.innerHTML = hitNews(hit, isInit)
      } else if (widgetParams.type === 'talent') {
        li.className = 'col-12 md-col-6 lg-col-4 xl-col-3 mb-8'
        li.innerHTML = hitTalent(hit, isInit)
      }

      widgetParams.container.querySelector('ul').appendChild(li)

      const modalControl = li.querySelector('[js-modal-control]')
      if (modalControl) {
        const saveAttr = modalControl.getAttribute('js-modal-control')
        modalControl.removeAttribute('js-modal-control')
        modalControl.setAttribute('js-modal-control', saveAttr)
      }
    })
  } else {
    widgetParams.container.querySelector('ul').innerHTML = ''
    widgetParams.container.querySelector('ul').nextElementSibling.classList.add('hidden')
    widgetParams.container.querySelector('ul').nextElementSibling.classList.remove('flex')

    const empty = document.createElement('p')
    empty.classList.add('empty')
    empty.innerHTML = config.trads['lists.empty']
    widgetParams.container.append(empty)
  }

  if (isInit2 === false || widgetParams.type !== 'contribution') {
    isInit = false
  }

  isInit2 = false
}

const customHits = connectInfiniteHits(renderInfiniteHits)

export default customHits
